// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalList_header__VqRWt","modalList":"ModalList_modalList__B9Ky_"};